import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../../helpers/urlHelper";

const Step4Confirmation = ({ patient, video, schedule, restart }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const assignContent = async () => {
            const payload = {
                doctorId: "67ea2e7d7f31d2c7e51ba12f",  // 👈 cambia los nombres para que el backend los entienda
                patientId: patient?._id,
                contentId: video?.id,
                contentTitle: video?.title,
                scheduleType: schedule,
                scheduledDate: null
            };

            console.log("📦 Payload que se enviará al backend:", payload); // 👈 Aquí ves exactamente qué se envía

            try {
                const response = await fetch(`${API_BASE_URL}/digimevo/assign`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data?.error || "Error al asignar contenido");
                }

                console.log("✅ Asignación exitosa:", data);
                setSuccess(true);
            } catch (err) {
                console.error("❌ Error:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        assignContent();
    }, [patient, video, schedule]);

    return (
        <div className="step active">
            <div className="section" style={{ textAlign: "center", paddingTop: "60px" }}>
                {loading ? (
                    <p>Asignando contenido...</p>
                ) : error ? (
                    <>
                        <div className="confirmation-icon">❌</div>
                        <h2 className="confirmation-title">Error</h2>
                        <p className="confirmation-message">{error}</p>
                    </>
                ) : (
                    <>
                        <div className="confirmation-icon">✅</div>
                        <h2 className="confirmation-title">¡Contenido asignado!</h2>
                        <p className="confirmation-message">
                            El contenido <strong>{video?.title}</strong> ha sido asignado con éxito a{" "}
                            <strong>{patient?.fullName}</strong>.
                            <br />
                            <br />
                            Se le enviará una notificación para que pueda visualizarlo.
                        </p>
                    </>
                )}

                {!loading && (
                    <button className="action-button" onClick={restart}>
                        Volver al inicio
                    </button>
                )}
            </div>
        </div>
    );
};

export default Step4Confirmation;
